<template>
    <div class="wrapper">
        <div class="animated calendar" v-if="hasDate === false">
            <div class="buttons">
                <a class="btn btn-primary" href="/activities">Takaisin</a>
                <a class="btn btn-success" :class="{disabled: !showPrevious}" @click="previous()">Edellinen</a>
                <a class="btn btn-success" :class="{disabled: !showNext}" @click="next()">Seuraava</a>
                <hr>
            </div>
            <div v-show="loading" class="loading">
                <i v-show="loading" class="fa fa-spinner fa-spin"></i>
            </div>
            <div id="activity-calendar">
                <div v-for="(year, index) in dates">
                    <div class="row">
                        <span class="year text-center col-xs-12 col-sm-12">
                            {{ index }}
                        </span>
                    </div>
                    <div v-for="(month, index) in year">
                        <div class="row">
                            <span class="month text-center col-xs-12 col-sm-12">
                                {{ renderMonthName(index) }}
                            </span>
                        </div>
                        <div class="row">
                            <a v-for="date in month" @click="selectDate(date.timestamp)" class="date" id="activity-calendar-link">
                                <span class="col-xs-12 col-sm-3 hidden-xs">
                                    viikko {{ formatWeekOfYear(date.timestamp) }}
                                </span>
                                <span class="col-xs-4 col-sm-3">
                                    {{ translateWeekday(date.timestamp) }}
                                </span>
                                <span class="col-xs-4 col-sm-3">
                                    {{ formatDate(date.timestamp) }}
                                </span>
                                <span class="col-xs-4 col-sm-3">
                                    {{ formatTime(date.timestamp) }}
                                </span>
                            </a>
                        </div>
                    </div> <!-- End for month, dates -->
                </div>
            </div>
        </div>
        <div class="animated list-wrapper" v-show="hasDate">
            <h4>{{attendees}} / {{maxAttendees}} </h4>
            <h4>{{ formatDate(selected) }} {{ formatTime(selected) }} <span class="glyphicon glyphicon-time" aria-hidden="true"></span></h4>
            <a class="btn btn-primary" @click="resetDate()">Takaisin</a>
            <a v-if="isRegistered" @click="toggleRegister()" class="btn btn-danger">Peruuta</a>
            <a v-else @click="toggleRegister()" class="btn btn-success">Varaa</a>
            <br>
            <qr-code
                :datetime="selected"
                :activity-id="activityId">
            </qr-code>
            <br>
            <attendee-list
                    :activity-id="activityId"
                    :datetime="selected"
                    :shows-check-in="showsCheckIn"
                    :shows-check-out="showsCheckOut">
            </attendee-list>
        </div>
    </div>
</template>

<script>
    import AttendeeList from './AttendeeList.vue';
    import QrCode from './QrCode.vue';
    import { EventBus } from '../event-bus';
    import axios from 'axios';
    import moment from 'moment';
    import Swal from 'sweetalert2';

    export default {
        name: 'activity-calendar',
        components: {
            AttendeeList,
            QrCode
        },
        props: {
            activityId: {
              type: Number,
              default: 0
            },
            showsCheckIn: {
                type: Boolean,
                default: false
            },
            showsCheckOut: {
                type: Boolean,
                default: false
            },
        },
        data: function()
        {
            return {
                dates:  [],
                pivot: moment(),
                direction: 1,
                selected: 0,
                hasDate: false,
                loading: false,
                isRegistered: {
                    type: Boolean,
                    default: false
                },
                attendees: 0,
                maxAttendees: 0,
                showNext: true,
                showPrevious: true
            }
        },
        mounted: function() {
           this.loadList();
           moment.locale('fi');
        },
        methods:
        {
            loadList: function()
            {
                this.loading = true;
                this.dates = [];
                axios.get('/api/activities/'+ this.activityId +'/calendar', {
                    params: {
                        'pivot': this.pivot.format('YYYY-MM-DD'),
                        'direction': this.direction
                    }
                }).then((response) => {
                   this.dates = response.data.dates;
                   this.showNext = response.data.showNext;
                   this.showPrevious = response.data.showPrevious;
                   this.loading = false;
                });
            },
            selectDate: function(date)
            {
                this.selected = date;
                this.hasDate = true;
                this.attendees = 0;

                //show checkin buttons
                if (this.showsCheckIn) {
                    EventBus.$emit('showCheckIn');
                }
                if (this.showsCheckOut) {
                    EventBus.$emit('showCheckOut');
                }
                EventBus.$emit('onSelectedDateChange', this.selected);
                this.getActivityStatus();
            },
            getActivityStatus: function()
            {
                axios.post('/api/activities/'+ this.activityId +'/status', {
                        'activity_date': this.selected
                }).then((response) => {
                    this.isRegistered = response.data.registerStatus;
                    this.attendees = response.data.attendees;
                    this.maxAttendees = response.data.maxAttendees;
                });
            },
            toggleRegister: function()
            {
                this.loading = true;
                axios.post('/api/activities/register/' + this.activityId, {
                        'activity_date': this.selected
                }).then(() => {
                    this.getActivityStatus();
                    EventBus.$emit('onNewRegistration', this.selected);
                    this.loading = false;
                }).catch(error => {
                    Swal.fire({
                        type: 'error',
                        title: "Jokin meni pieleen.",
                        text: error.response.data.errors.title
                    })
                });
            },
            resetDate: function()
            {
                this.selected = 0;
                this.hasDate = false;
            },

            firstDate: function() {
                let firstMonth = Object.keys(this.dates)[0];
                let firstWeek = Object.keys(this.dates[firstMonth])[0];
                let firstDate = this.dates[firstMonth][firstWeek][0].timestamp;
                return moment.unix(firstDate);
            },
            lastDate: function() {
                let lastMonth = Object.keys(this.dates).pop();
                let lastWeek = Object.keys(this.dates[lastMonth]).pop();
                let lastDate = this.dates[lastMonth][lastWeek].pop().timestamp;
                return moment.unix(lastDate);
            },
            previous: function()
            {
                if (!(this.dates == undefined || this.dates == null || this.dates.length == 0)) {
                    this.pivot = this.firstDate();
                }
                this.direction = 0;
                this.loadList();
            },
            next: function()
            {
                if (!(this.dates == undefined || this.dates == null || this.dates.length == 0)) {
                    this.pivot = this.lastDate();
                }

                this.direction = 1;
                this.loadList();
            },
            translateWeekday: function(timestamp)
            {
                return moment.unix(timestamp).format('dddd');
            },
            formatDate: function(timestamp)
            {
                return moment.unix(timestamp).format('DD.MM.YYYY')
            },
            formatWeekOfYear: function(timestamp)
            {
                return moment.unix(timestamp).week();
            },
            formatTime: function(timestamp)
            {
                return moment.unix(timestamp).format('HH:mm')
            },
            renderMonthName(monthNumber) {
                return moment(monthNumber, 'M').format('MMMM');
            }
        },
        events:
        {
            closeModal: function(contents)
            {
                this.getActivityStatus();
            }
        }
    }
</script>

<style lang="scss">
@import 'resources/assets/sass/_variables.scss';

#activity-calendar
{
    background-image: -webkit-linear-gradient(#e5e5e5 49px,#eaeaea 49px);
    background-image: linear-gradient(#e5e5e5 49px,#eaeaea 49px);
    -webkit-background-size: 100% 98px;
    background-size: 100% 98px;
    -webkit-box-shadow: 0 0 2px rgba(0,0,0,.12), 0 2px 4px rgba(0,0,0,.24);
    box-shadow: 0 0 2px rgba(0,0,0,.12), 0 2px 4px rgba(0,0,0,.24);
    margin-bottom: 20px;
    margin-left: 0px;
    margin-right:0px;
}

.attendees {

    margin-left: -15px;
    margin-right: -15px;

    h4 {
        font-size: 1.4rem;
    }

    font-size: 1.8rem;
    @media (max-width: 500px) {
        font-size: 1.4rem;
    }

    .month, .year, a.date {
        background: $panel-default-body;
        padding-top: 5px;
        padding-bottom: 5px;
        box-shadow: 0 1px 0 0 rgba(0,0,0,.1);
        display: flex;

        align-items: center;
        border-bottom: 1px solid #ececec;
        color: $typography-color-first;
        span {
            padding: 0 0 0 10px;
        }
    }

    .month {
        background:darken($panel-default-body, 20%);
    }

    .year {
        display: inline-block;
        background:darken($panel-default-body, 30%);
    }

    a.date:hover {
        text-decoration: none;
        background: lighten($panel-default-body, 30%);
        border-left: 2px solid #046bc7;
        cursor: pointer;
    }

    a.title {
        text-transform: uppercase;
    }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-active {
  transform: translateX(10px);
  opacity: 0;
}
</style>
